import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 shadow-none backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="group flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-eye-2-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold text-foreground-950">吃瓜直播</span>
            <span className="text-[10px] tracking-widest text-foreground-500">围观群众集合地</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.key}
              href={`#${l.key}`}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="btn hidden bg-primary-500 px-4 py-2 text-sm text-background-50 hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-notification-3-line"></i> 订阅提醒
          </a>
          <button
            aria-label="打开菜单"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg text-foreground-800 transition-colors hover:bg-background-200 lg:hidden"
            onClick={() => setOpen((v) => !v)}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.key}
                href={`#${l.key}`}
                onClick={() => setOpen(false)}
                className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-200"
              >
                <i className={`${l.icon} text-primary-600`}></i>
                {l.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="btn mt-2 bg-primary-500 px-4 py-2.5 text-sm text-background-50 hover:bg-primary-600"
            >
              <i className="ri-notification-3-line"></i> 订阅后续提醒
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}